import React, { FC } from 'react';

import { Grid, Paper } from '@material-ui/core';

import { AssignResultsProvider } from '../Common/AssignResults/Context/AssignResults.context';
import LeaderboardFilter from '../Common/LeaderboardFilter/LeaderboardFilter';
import ResultsTable from './Components/ResultsTable/ResultsTable';

export const AdminEventLeaderboard: FC = () => {
  return (
    <AssignResultsProvider>
      <div className="assign-results admin-event-leaderboard">
        <Grid className="grid" container={true} spacing={0}>
          <Grid className="grid-item" item={true} xs={4}>
            <LeaderboardFilter />
          </Grid>

          <Grid className="grid-item" item={true} xs={8}>
            <Paper elevation={1} className="paper result-table-paper">
              <ResultsTable />
            </Paper>
          </Grid>
        </Grid>
      </div>
    </AssignResultsProvider>
  );
};
